import request, { projectRequest } from 'store/utils/request';

export const getProjectRequest = async (projectAccount, projectSlug) => {
  try {
    return await request.get(`/${projectAccount}/projects/${projectSlug}/`);
  } catch (error) {
    throw error;
  }
};

export const getPurgeProjectsRequest = async () => {
  try {
    return await projectRequest.get(`/purge/`, {
      timeout: 3 * 60 * 1000,
    });
  } catch (error) {
    throw error;
  }
};

export const purgeProjectRequest = async data => {
  try {
    return await projectRequest.post(`/purge/`, data, {
      timeout: 3 * 60 * 1000,
    });
  } catch (error) {
    throw error;
  }
};

export const exportProjectRequest = async (data, settings = {}) => {
  try {
    return await projectRequest.post(`/export/`, data, {
      responseType: 'blob',
      timeout: 6 * 60 * 1000, // Some project needs much time in order to complete export
      ...settings,
    });
  } catch (error) {
    throw error;
  }
};

export const getGeneralProjectSettingsRequest = async () => {
  try {
    return await projectRequest.get(`/info/`);
  } catch (error) {
    throw error;
  }
};

export const updateProjectNameRequest = async data => {
  try {
    return await projectRequest.put(`/`, data);
  } catch (error) {
    throw error;
  }
};

export const createProjectSnapshotRequest = async data => {
  try {
    return await projectRequest.post(`/snapshots/`, data, {
      timeout: 3 * 60 * 1000,
    });
  } catch (error) {
    throw error;
  }
};

export const getProjectSnapshotsRequest = async () => {
  try {
    return await projectRequest.get(`/snapshots/`);
  } catch (error) {
    throw error;
  }
};

export const downloadProjectSnapshotRequest = async snapshotId => {
  try {
    return await projectRequest.get(`/snapshots/${snapshotId}/download/`, {
      responseType: 'blob',
      timeout: 60 * 1000,
    });
  } catch (error) {
    throw error;
  }
};

export const rollbackProjectRequest = async snapshotId => {
  try {
    return await projectRequest.post(
      `/snapshots/${snapshotId}/rollback/`,
      {},
      {
        timeout: 3 * 60 * 1000, // some projects need at least ~2.5min to rollback
      },
    );
  } catch (error) {
    throw error;
  }
};

export const deleteProjectRequest = async () => {
  try {
    return await projectRequest.delete(`/`);
  } catch (error) {
    throw error;
  }
};

export const initializeVersionControl = ({
  server,
  repo,
  group,
  project,
  account,
}) =>
  request.post(`/${account}/projects/${project}/version_control/init/`, {
    server_id: server,
    repo_name: repo,
    group,
  });
